export function initModeSwitcher(defaultModeNumber = 0) {
  const modes = ['default', 'select'];
  const [defaultMode, selectMode] = modes;
  let mode = modes[defaultModeNumber];
  const fnOnSelectMode = [];
  const fnOnDefaultMode = [];

  return {
    switchToSelect: () => {
      mode = selectMode;
      fnOnSelectMode.forEach((fn) => fn());
    },
    switchToDefaultMode: () => {
      mode = defaultMode;
      fnOnDefaultMode.forEach((fn) => fn());
    },
    mode: () => mode,
    isSelectMode: () => mode === selectMode,
    isDefaultMode: () => mode === defaultMode,
    onSelectMode: (fn) => {
      fnOnSelectMode.push(fn);
    },
    onDefaultMode: (fn) => {
      fnOnDefaultMode.push(fn);
    },
  };
}
